module.exports = __webpack_public_path__ + "img/ISK.f4c3aca3.svg";